import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { RestLink } from 'apollo-link-rest';

const BOWTIE_API_BASE_ENDPOINT = process.env.REACT_APP_API_BASE_ENDPOINT;

const authLink = setContext(async ({ headers }) => {
  const locale = localStorage.getItem('locale');
  const extraHeaders = {};

  if (locale) extraHeaders['accept-language'] = locale;

  return { headers: { ...headers, ...extraHeaders } };
});

const restLink = new RestLink({ uri: `${BOWTIE_API_BASE_ENDPOINT}/customer` });

const client = new ApolloClient({
  link: ApolloLink.from([authLink, restLink]),
  cache: new InMemoryCache(),
});

export default client;
